<template>
    <base-card
        :imgSrc="consumerImage"
        :imgAlt="consumerName"
        v-on="$listeners"
    >
        <b-card-body>
            <b-card-title>{{ consumerName }}</b-card-title>
        </b-card-body>
        <b-card-footer>
            <b-card-sub-title>Group: {{ consumer.locationGroup }}</b-card-sub-title>
        </b-card-footer>
    </base-card>
</template>

<script>
import BaseCard       from "@/components/base/Card";
import {API_ENDPOINT} from '@/configs';

export default {
    name:       'ConsumerCard',
    components: {BaseCard},
    props:      {
        consumer: {
            type:     Object,
            required: true
        }
    },
    data() {
        return {
            API_ENDPOINT,
        }
    },
    computed: {
        consumerName() {
            return `${this.consumer.firstname} ${this.consumer.lastname}`;
        },
        consumerImage() {
            return this.consumer.image;
        },
    },
}
</script>
